import { useUnit } from "effector-react"
import userStore from "stores/user"

export default function useCurrentUser() {
    return {
        user: useUnit(userStore.$user),
        changeLanguage: userStore.changeLanguage
    }
}
